import React, { useState } from "react"
import styles from './coberturas.module.css'
import Subtitle from "../../../../components/Subtitle"
import CardFull from "../card/full"
import ResumenCoberturas from "../resumen-coberturas/resumen-coberturas"
import Leyendas from "../leyendas/leyendas"

const Coberturas = ({ productos, textoCoberturas, prodCobers }) => {
    const initialState = {
        expandeProd: (productos !== null && productos !== undefined ?
            productos.map(producto => {
                return {
                    id: producto.codigoProducto,
                    valor: false
                }
            }) : null),
        coberturasProducto: prodCobers
    }

    const [state, setState] = useState(initialState)

    return (
        <React.Fragment>
            <div className={styles.wrapFirstcols}>
                <CardFull>
                    <Subtitle sname={"Coberturas"} smostrar={true} />
                    <div className={styles.container__wrapper}>
                        <div className={`${styles.descripCard} ${styles.descripCardFix}`}>
                            Este es nuestro plan para asegurar el cumplimiento de tus metas y de tu familia:
                        </div>
                        {prodCobers &&
                            <ResumenCoberturas
                                productos={prodCobers}
                                state={state}
                                setState={setState}
                                leyenda={textoCoberturas}
                            />
                        }
                        {textoCoberturas &&
                            <Leyendas
                                textCober={textoCoberturas}
                            />
                        }
                    </div>
                </CardFull>
            </div>

        </React.Fragment>
    )
}

export default Coberturas;